import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Deadlines = () => {
  return (
    <React.Fragment>
      <SEO title="Important Dates | ICSI 2023" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Important Dates"
        content="For Authors"
        contentTwo="Deadlines"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <p>
            <h4>Deadlines for ICSI&apos;2023:</h4>
          </p>
          <br />
          <table className="deadline">
            <tbody>
              <tr>
                <th width="200">Event</th>
                <th width="400">Deadline</th>
              </tr>
              <tr>
                <td>
                  <strong>
                    <del>
                      Special Session proposals
                    </del>
                  </strong>
                </td>
                <td>
                  <strong>
                    <del>
                      January 15, 2023
                    </del>
                  </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                      Paper submission
                  </strong>
                </td>
                <td>
                  <strong>
                  <del>
                      January 15, 2023
                  </del>
                  </strong>
                  &nbsp;&nbsp;
                  <br/>
                  <strong>
                  <del>
                  February 28, 2023
                  </del>
                  </strong>
                  {/* <br/> */}
                  {/* <strong>
                    <span className="font-red">
                    March 17, 2023
                    </span >
                  </strong> */}
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <strong></strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    
                    Notification of acceptance

                    
                    </strong>
                </td>
                <td>
                  <strong>
                    
                    March 30, 2023
                    
                    </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    
                    Camera-ready copy

                    
                    </strong>
                </td>
                <td>
                  <strong>
                    
                    April 25, 2023

                    
                    </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    
                    Author registration

                    
                    </strong>
                </td>
                <td>
                  <strong>
                    
                    April 25, 2023

                    
                    </strong>
                </td>
              </tr>

            </tbody>
          </table>
          {/* <div className="row">
            <h5>Click the link below to submit your paper to ICSI 2022</h5>
            <a
              className="btn btn-primary"
              href="https://easychair.org/conferences/?conf=icsi2022"
            >
              ICSI Online Paper Submission
            </a>
          </div> */}
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
        <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Deadlines;
